// extracted by mini-css-extract-plugin
export default {"SearchBar":"style_SearchBar__1clXp"};